module.exports = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="


/*****************
 ** WEBPACK FOOTER
 ** /home/intellect/public_html/e-projekty/2016/czesci-samochodowe/carox.pl/theme/~/fancybox/dist/img/blank.gif
 ** module id = 15
 ** module chunks = 0
 **/